import {
  Building2,
  FileText,
  Receipt,
  CreditCard,
  Users,
  Calendar,
  TrendingUp,
  LineChart,
  Store,
  Shield,
  ShoppingCart,
  Activity,
  FolderOpen,
  Hexagon,
  FileKey,
  Link,
  Webhook,
  History,
  Package,
  Puzzle,
  Globe,
  DollarSign,
  User as UserIcon,
  Layers,
  Database,
  CloudUpload,
  UserRoundCog,
  Import,
  IdCard,
  UserPlus,
  Download,
  Bell,
  Settings,
  MoreVertical,
  LogOut,
  ArrowRight,
  Lock,
  Unlock,
  RefreshCw,
  PanelLeft,
  PanelLeftClose,
  Gauge,
  Code,
} from "lucide-react";

// Helper function to create consistent outline icons
export const createIcon = (IconComponent) => (
  <IconComponent
    size={16}
    strokeWidth={1.5}
    fill="none"
    stroke="currentColor"
  />
);

// Icon configuration for ContentHeader component
export const contentHeaderIconConfig = {
  // Main navigation
  "/company": Building2,
  "/contacts": IdCard,
  "/customers": Users,
  "/selfserveusers": UserPlus,
  "/sell/proposals": FileText,
  "/collect/invoice": Receipt,
  "/collect/payments": CreditCard,
  "/subscriptions": Calendar,
  "/upsellanddownsell": TrendingUp,

  // Configure section
  "/configure/plans": Layers,
  "/configure/products": Package,
  "/configure/market": Globe,
  "/configure/events": Activity,
  "/configure/integrations": Link,
  "/configure/webhooks": Webhook,

  // Settings area
  "/profile": UserIcon,
  "/settings/configurebilling/billingunits": Gauge,
  "/settings/configurebilling/usageSources": Database,
  "/settings/configurebilling/usageCompilation": Layers,
  "/settings/configurebilling/usageCollection": CloudUpload,
  "/settings/configurebilling/systemFeatures": Puzzle,
  "/settings/configurebilling/billingLogic": Activity,
  "/selfservecheckout/configure": ShoppingCart,
  "/organisationDetails": Store,
  "/platformSettings": Shield,
  "/settings/userManagement": Users,
  "/settings/roles": UserRoundCog,
  "/settings/permissions": FileKey,
  "/settings/documentManagement": FolderOpen,
  "/settings/imports": Import,
  "/settings/migrations": RefreshCw,
  "/settings/exports": Download,
  "/settings/objectCustomization": Hexagon,

  // Misc
  "/pricing": DollarSign,
};

// Icon configuration for SideNav component
export const sideNavIconConfig = {
  // Main navigation items
  mainNav: {
    Revenue: LineChart,
    Companies: Building2,
    Contacts: IdCard,
    "Self serve users": UserPlus,
    Proposals: FileText,
    Invoices: Receipt,
    Payments: CreditCard,
    Subscriptions: Calendar,
    "Upsell / Downsell": TrendingUp,
    Configure: Settings,
  },

  // Object customization menu items (lowercase)
  objectCustomization: {
    company: Building2,
    plan: Layers,
    product: Package,
    market: Globe,
    billingUnit: FileText,
    usageSource: Database,
    usageCompilation: Layers,
    userManagement: Users,
    systemFeatures: Puzzle,
  },

  // Settings navigation items
  settingsNav: {
    "Your profile": UserIcon,
    "Configure billing": Receipt,
    "Billing logic": Activity,
    "Configure Self-checkout": ShoppingCart,
    "Organisation details": Store,
    "Platform Settings": Shield,
    "User management": Users,
    "Roles & Permissions": UserRoundCog,
    "Document management": FolderOpen,
    Imports: Import,
    Migrations: RefreshCw,
    Exports: Download,
    "Object customization": Hexagon,
    Permissions: FileKey,
  },

  // Additional icons used in SideNav
  additional: {
    Updates: Bell,
    Settings: Settings,
    LogOut: LogOut,
    MoreVertical: MoreVertical,
    ArrowRight: ArrowRight,
    Lock: Lock,
    Unlock: Unlock,
    RefreshCw: RefreshCw,
    PanelLeft: PanelLeft,
    PanelLeftClose: PanelLeftClose,
    Code: Code,
  },

  // Configure dropdown items
  configureDropdown: {
    Plans: Layers,
    "Products & Add Ons": Package,
    Markets: Globe,
    Events: Activity,
    Integrations: Link,
    Webhooks: Webhook,
    "Time Machine": History,
  },

  // Configure billing dropdown items
  configureBillingDropdown: {
    "Billing unit": Gauge,
    "Usage sources": Database,
    "Usage compilation": Layers,
    "Usage collection": CloudUpload,
    "System features": Puzzle,
  },
};

// Function to resolve icon by path for ContentHeader
export const resolveIconByPath = (pathname) => {
  const entry = Object.entries(contentHeaderIconConfig).find(([path]) =>
    pathname.startsWith(path)
  );
  return entry ? entry[1] : null;
};

// Function to get icon for SideNav menu item
export const getSideNavIcon = (menuItem, type = "mainNav") => {
  const config = sideNavIconConfig[type];
  return config?.[menuItem] || null;
};
